import React from 'react';

const CardSkeleton = () => {
  return (
    <div className="relative bg-gray-200 text-left rounded-3xl p-8 shadow-sm flex flex-col gap-3 w-full min-w-[300px] max-w-[350px] min-h-[280px] animate-pulse">
      <div className="flex items-center gap-2">
        {/* Icon placeholder */}
        <div className="w-6 h-6 bg-gray-300 rounded-md" />
        {/* Title placeholder */}
        <div className="w-32 h-6 bg-gray-300 rounded-md" />
      </div>

      {/* Copy placeholder */}
      <div className="h-4 w-1/2 bg-gray-300 rounded-md mt-6" />

      {/* Main metric placeholder */}
      <div className="h-7 w-24 bg-gray-300 rounded-md" />

      {/* Details placeholder */}
      <div className="h-4 w-3/4 bg-gray-300 rounded-md mb-10" />

      {/* Arrow icon placeholder */}
      <div className="absolute bottom-4 right-4 w-5 h-5 bg-gray-300 rounded-md" />
    </div>
  );
};

export default CardSkeleton;
